import { Component, OnInit } from '@angular/core';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { NoticeService } from 'src/app/services/notice.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'view-notices',
  templateUrl: './view-notices.component.html',
})

export class ViewNoticeComponent implements OnInit {

    hearingDateList: any[];
    labelsList = [];
    selectedLabelsList = [];
    cols: any[];

    filterOptions: any = {
      filterText: '',
      casesNeedSched: '',
      casesOnDate: '',
    };

  displayState: any = {
        workingDiv: false,
        gridDiv: false,
        labelDiv: false
    };
    myHearing: any;

    constructor(private messageService: MessageService, private utilService: UtilitiesService,
                private confirmationService: ConfirmationService, private noticeService: NoticeService,
                private datePipe: DatePipe) { }

    ngOnInit() {
      this.cols = [
        { field: 'row1', header: 'To' },
        { field: 'row2', header: 'Street Addr' },
        { field: 'row3', header: 'Street Addr2'},
        { field: 'row4', header: 'Agency Contact'},
      ];

      this.displayState.gridDiv = false;
      this.getNoticeDates();
    }

    // get list of defined Hearing Dates
    getNoticeDates() {
        this.displayState.workingDiv = true;
        this.displayState.gridDiv = false;
        this.displayState.labelDiv = false;
        let tdy = new Date();
        this.noticeService.getNoticesGen('NL','','').subscribe(data => {
            if (data) {
                this.utilService.doAudit(data, 'response from getNoticeGen');
                this.hearingDateList = data.filter(t=> {
                    let tHearDt = new Date(t.hearingDate);
                    // return t;   // FOR TESTING ONLY - return ALL hearing dates
                    return tHearDt > tdy ? t : null; // return ONLY future dates
                });
                this.hearingDateList.sort((a, b) => {
                  // @ts-ignore
                  return new Date(a.hearingDate) - new Date(b.hearingDate);
                });

            }
            this.displayState.workingDiv = false;
            this.displayState.gridDiv = true;
        })
    }

    // triggered when user selects a Hearing Date, to display PDF of Notices
    printNotices(hearing: any) {
      let hearingId = hearing.hearingId;
      let noticeType = hearing.noticeType;
      this.utilService.doAudit(hearing,'selected hearing - printing notices');
      this.displayState.workingDiv = true;
      this.noticeService.getPrintNoticesPdf(hearingId, noticeType).subscribe(data => {
        this.utilService.doAudit('got response from getPrintNoticesPdf:');
        this.displayState.workingDiv = false;
        if (data) {
          const myUrl = URL.createObjectURL(data);
          window.open(myUrl, '_blank');
          URL.revokeObjectURL(myUrl);
        } else {
          this.showToast({ key: 'info', severity: 'error', detail: 'Problem generating notices!', summary: 'ERROR' });
          return;
        }
      });

    }
  cancelLabelChoose() {
      this.displayState.labelDiv = false;
      this.labelsList = [];
      this.selectedLabelsList = [];
    }
    chooseLabels(hearing: any) {
      this.myHearing = hearing;
      let hearingId = hearing.hearingId;
      let noticeType = hearing.noticeType;
      this.utilService.doAudit(hearing,'selected hearing');
      this.noticeService.getNoticeLabels(hearingId, noticeType).subscribe(data => {
        this.utilService.doAudit(data,'got response from getNoticeLables:');
        if (data) {
          this.labelsList = data;
        }
        this.displayState.labelDiv = true;
      });
    }

    printLabels() {
      if (this.selectedLabelsList.length < 1) {
        this.showToast({ key: 'info', severity: 'error', detail: 'No labels selected!', summary: 'Print Labels' });
        return;
      }
      this.utilService.doAudit(this.selectedLabelsList,'selected labels');
      this.noticeService.getSelectedLabels(this.selectedLabelsList).subscribe(data => {
        this.utilService.doAudit('got response from getNoticeLables:');
        if (data) {
          const myUrl = URL.createObjectURL(data);
          window.open(myUrl, '_blank');
          URL.revokeObjectURL(myUrl);
        } else {
          this.showToast({ key: 'info', severity: 'error', detail: 'Problem generating labels!', summary: 'ERROR' });
          return;
        }
      });
    }

    updateStatuses(hearing: any) {
        this.myHearing = hearing;
        let hearDate = this.datePipe.transform(hearing.hearingDate, 'MM/dd/yyyy');
        // this.showToast({ key: 'info', severity: 'info', detail: 'This option is not ready yet!.', summary: '' });
        //this.showConfirm('Ready to update statuses for cases scheduled on: ' + hearDate);
        this.showConfirm2('Ready to update statuses for cases scheduled on: ' + hearDate);
    }

    showToast(msg: Message) {
        this.messageService.add(msg);
    }

    showConfirm(msgDetails: string) {
        this.messageService.clear();
        this.messageService.add({key: 'conf', sticky: true, severity: 'warn', summary: 'OK to proceed?', detail: msgDetails});
    }

    showConfirm2(msgDetails: string) {
        this.confirmationService.confirm({
            message: msgDetails,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                // this.messageService.add({key: 'info', severity:'info', summary:'Confirmed', detail:'You have accepted'});
                this.onConfirm();
            },
            reject: (type) => {
                this.onReject();
            },
            key: 'confDialog'
        });

    }

    onConfirm() {
        if ( !this.myHearing.hearingId) {
            this.showToast({ key: 'info', severity: 'error', detail: 'Nothing done!', summary: 'No hearing found' });
            return;
        }
        // else, continue...
        this.utilService.doAudit(this.myHearing, 'myHearing:');
        this.noticeService.updateNoticeStatuses(this.myHearing.hearingId, this.myHearing.noticeType).subscribe(data => {
            this.utilService.doAudit(data, 'returned from updateNoticeStatuses:');
            this.showToast({ key: 'info', severity: 'success', detail: 'Case(s) Status updated', summary: 'Info' });
            this.getNoticeDates();   // refresh the list of Hearing Dates
        });
        this.messageService.clear('conf');
    }

    onReject() {
        this.utilService.doAudit('hit onReject');
        this.showToast({ key: 'info', severity: 'info', detail: 'Nothing done.', summary: '' });
        this.messageService.clear('conf');
    }

    clear() {
        this.messageService.clear();
    }

}
